export enum ETAPASNUMERO {
  PASO1 = 0,
  PASO2 = 1,
  PASO3 = 2,
}
